



















import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ISysVar } from '@/models/sysvar';
import MessageMixin from '@/components/message-mixin';
import Message from '@/components/message.vue';
import { debounce } from 'ts-debounce';

@Component({
  components: { Message }
})
export default class SysvarEdit extends mixins(MessageMixin) {

  amUpdating = false;

  @Prop({ required: true })
  sysvar?: ISysVar;

  _value: any = true;

  created() {
    this._value = this.sysvar?.value;
    this.apiSetValue = debounce(this.apiSetValue, 500);
  }

  async apiSetValue(newVal: any) {
    if (newVal === '') {
      this.setMessage('error', 'You must enter a value');
      return;
    }

    this.amUpdating = true;
    try {
      this.setMessage('pending', 'One second, updating...');
      await this.$api.get(`/api/sysvar/${this.sysvar?.id}/${newVal}`)
      this.message = null;
    } catch (e) {
      this.setMessage('error', 'Error updating value: ' + e);
    } finally {
      this.amUpdating = false;
    }
  }

  get value(): any {
    return this._value;
  }

  set value(newVal) {
    this.apiSetValue(newVal);
    this._value = newVal;
  }
}
